const ABSOLUTE_URL_REGEX = /^https?:\/\//i;

export const resolveApiImageUrl = (value) => {
  if (typeof value !== "string") return "";

  const trimmed = value.trim();
  if (!trimmed || trimmed === "1") return "";

  if (ABSOLUTE_URL_REGEX.test(trimmed) || trimmed.startsWith("data:")) {
    return trimmed;
  }

  if (trimmed.startsWith("//")) {
    return `https:${trimmed}`;
  }

  const baseUrl = (process.env.REACT_APP_BASE_URL || "").trim();
  if (!baseUrl) return trimmed;

  const normalizedBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
  const normalizedPath = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return `${normalizedBase}${normalizedPath}`;
};

